module.exports = __webpack_public_path__ + "static/media/mobile.9e40e556.svg";